import { render, staticRenderFns } from "./RecycleModule.vue?vue&type=template&id=48966793&scoped=true&"
import script from "./RecycleModule.vue?vue&type=script&lang=js&"
export * from "./RecycleModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48966793",
  null
  
)

export default component.exports